angular
    .module("skillBuilderSaaS")
    .directive("closeHelp", function () {
    return {
        restrict: "A",
        link: function (_scope, element, attr) {
            if (attr && attr.closeHelp) {
                element.bind("click", function () {
                    angular.element(".elevio-close-btn").click();
                });
            }
        }
    };
});
